import React from 'react';
import './style.css';

const BrandingPanel: React.FC = () => {
  return (
    <aside className="branding-panel">
      <div className="branding-bg" aria-hidden="true">
        <span className="glow glow-1" />
        <span className="glow glow-2" />
        <span className="ring ring-1" />
        <span className="ring ring-2" />
        <span className="ring ring-3" />
      </div>

      <div className="branding-content">
        <div className="branding-brand">
          <img src="/lo_icon.svg" alt="" className="branding-trophy" />
          <span className="branding-wordmark">Live<span>Olympiad</span></span>
        </div>

        <h1 className="branding-headline">Where young minds compete&nbsp;and&nbsp;grow.</h1>
        <p className="branding-sub">
          Timed mock olympiads in Math, Science and English — sit real exam-style
          tests, get your score instantly, and watch your progress climb.
        </p>

        <ul className="branding-points">
          <li><span className="dot" /> Real, exam-style timed tests</li>
          <li><span className="dot" /> Instant scoring after every mock</li>
          {/* The public site sells Classes 1-8; advertising 1-10 here promised a
              paper to families who cannot enter (EXP-08). */}
          <li><span className="dot" /> Made for Classes 1–8</li>
        </ul>
      </div>
    </aside>
  );
};

export default BrandingPanel;
